//* Vue
import type { SetupContext } from "vue";
//* 组件库
import type { UiModal, UiInput } from "various-ui";
//* 组件属性
import type { SearchGeneEmits, SearchGeneProps } from "./index";
import { useOptions } from "./options";

export const useComposable = (define: SearchGeneProps, emits: SetupContext<typeof SearchGeneEmits>["emit"]) => {
    //* 配置
    const options = useOptions();

    //* 响应式变量
    const refs = {
        data: ref<any[]>([]),
        page: ref<number>(1),
        count: ref<number>(0),
        select: ref<string>(""),
        loading: ref<boolean>(false),
        keyword: ref<string>(""),
        keyword_cache: ref<string>(""),
    };

    //* 节点
    const nodes = {
        modal: ref<InstanceType<typeof UiModal>>(),
        input: ref<InstanceType<typeof UiInput>>(),
    };

    //* 函数列表
    const methods = {
        //* 选择函数
        select: (data: any) => {
            if (define.trigger == "none") {
                //* 响应事件
                emits("change", data);
                //* 关闭窗口
                nodes.modal.value?.closeModal();
            } else {
                //* 接口请求
                refs.loading.value = true;
                api.frontend("/api/gene/mrnas-info", {
                    data: { id: data.id },
                    finally: () => (refs.loading.value = false),
                    success: (response) => {
                        //* 响应事件
                        emits("change", Object.assign(response, { id: data.id, name: data.gene_name }));
                        //* 关闭窗口
                        nodes.modal.value?.closeModal();
                    },
                });
            }
        },

        //* 搜索函数
        search: (number?: number) => {
            //* 数据初始化
            const keyword = refs.keyword.value?.trim?.() || "";
            const data = { keyword: keyword, limit: 10, page: number || refs.page.value || 1, mode: "gene", selector: define.selector };
            //* 检测是否需要设置
            if (!define.selector?.length && refs.select.value) data.selector = [{ key: "taxonomy_id", value: refs.select.value }];
            //* 检测是否存在有效数据
            if (keyword) {
                refs.loading.value = true;
                api.frontend("/api/search", {
                    method: "POST",
                    data: data,
                    success: (response) => {
                        //* 数据更新
                        refs.data.value = response?.data || [];
                        refs.count.value = response?.count || 0;
                        refs.keyword_cache.value = keyword;
                    },
                    finally: () => {
                        refs.loading.value = false;
                    },
                });
            }
        },

        //* 弹出窗开始
        open: (keyword?: string) => {
            //* 打开弹出窗
            nodes.modal.value?.openModal();
            nextTick(() => {
                nodes.input.value?.focus();
            });

            //* 数据初始化
            refs.data.value = [];
            refs.keyword.value = keyword?.trim() || "";
            //* 存在ID则请求接口获取数据
            if (refs.keyword.value) {
                methods.search(1);
            } else {
                refs.keyword_cache.value = "";
            }
        },
    };

    return { refs, nodes, methods, options };
};
